// Authentication UI component - Alpine.js

export const auth = () => ({
  // State
  showLogin: true,
  loading: false,
  isOffline: false,
  
  // Form data
  loginForm: {
    email: '',
    password: ''
  },
  
  registerForm: {
    email: '',
    password: '',
    confirmPassword: '',
    username: ''
  },
  
  // Error messages
  errors: {
    login: null,
    register: null
  },
  
  // Initialize component
  init() {
    console.log('Auth component initialized');
    
    // Check if offline
    this.isOffline = !navigator.onLine;
    window.addEventListener('online', () => {
      this.isOffline = false;
    });
    window.addEventListener('offline', () => {
      this.isOffline = true;
    });
    
    // Pre-fill test account for development
    if (import.meta.env.DEV) {
      this.loginForm.email = 'test@destiny-reborn.com';
      this.loginForm.password = 'testpass123';
    }
  },
  
  // Toggle between login and register
  toggleForm() {
    this.showLogin = !this.showLogin;
    this.clearErrors();
    this.clearForms();
  },
  
  // Clear error messages
  clearErrors() {
    this.errors.login = null;
    this.errors.register = null;
  },
  
  // Clear form data
  clearForms() {
    this.loginForm = { email: '', password: '' };
    this.registerForm = { email: '', password: '', confirmPassword: '', username: '' };
  },
  
  // Validate login form
  validateLogin() {
    if (!this.loginForm.email) {
      this.errors.login = 'Email es requerido';
      return false;
    }
    
    if (!this.loginForm.password) {
      this.errors.login = 'Contraseña es requerida';
      return false;
    }
    
    return true;
  },
  
  // Validate register form
  validateRegister() {
    if (!this.registerForm.email) {
      this.errors.register = 'Email es requerido';
      return false;
    }
    
    if (!this.isValidEmail(this.registerForm.email)) {
      this.errors.register = 'Email inválido';
      return false;
    }
    
    if (!this.registerForm.username) {
      this.errors.register = 'Nombre de usuario es requerido';
      return false;
    }
    
    if (this.registerForm.username.length < 3 || this.registerForm.username.length > 20) {
      this.errors.register = 'Nombre de usuario debe tener entre 3 y 20 caracteres';
      return false;
    }
    
    if (!this.registerForm.password) {
      this.errors.register = 'Contraseña es requerida';
      return false;
    }
    
    if (this.registerForm.password.length < 8) {
      this.errors.register = 'Contraseña debe tener al menos 8 caracteres';
      return false;
    }
    
    if (this.registerForm.password !== this.registerForm.confirmPassword) {
      this.errors.register = 'Las contraseñas no coinciden';
      return false;
    }
    
    return true;
  },
  
  // Email validation helper
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  
  // Handle login
  async handleLogin() {
    this.clearErrors();
    
    if (this.isOffline) {
      this.errors.login = 'No se puede iniciar sesión sin conexión';
      return;
    }
    
    if (!this.validateLogin()) {
      return;
    }
    
    this.loading = true;
    
    try {
      const store = this.$store.app;
      await store.login(this.loginForm.email, this.loginForm.password);
      
      // Login successful, the store will handle UI updates
      console.log('Login completed successfully');
      
    } catch (error) {
      console.error('Login error:', error);
      this.errors.login = error.message || 'Error al iniciar sesión';
    } finally {
      this.loading = false;
    }
  },
  
  // Handle registration
  async handleRegister() {
    this.clearErrors();
    
    if (this.isOffline) {
      this.errors.register = 'No se puede crear cuenta sin conexión';
      return;
    }
    
    if (!this.validateRegister()) {
      return;
    }
    
    this.loading = true;
    
    try {
      const store = this.$store.app;
      await store.register(
        this.registerForm.email,
        this.registerForm.password,
        this.registerForm.username
      );
      
      // Registration successful, the store will handle UI updates
      console.log('Registration completed successfully');
      
    } catch (error) {
      console.error('Registration error:', error);
      this.errors.register = error.message || 'Error al crear cuenta';
    } finally {
      this.loading = false;
    }
  },
  
  // Handle demo login (quick login for testing)
  async handleDemoLogin() {
    this.clearErrors();
    
    if (this.isOffline) {
      this.errors.login = 'Demo no disponible sin conexión';
      return;
    }
    
    this.loading = true;
    
    try {
      const store = this.$store.app;
      await store.login('test@destiny-reborn.com', 'testpass123');
      
      console.log('Demo login completed successfully');
      
    } catch (error) {
      console.error('Demo login error:', error);
      this.errors.login = 'Demo login no disponible';
    } finally {
      this.loading = false;
    }
  },
  
  // Get form title
  get formTitle() {
    return this.showLogin ? 'Iniciar Sesión' : 'Crear Cuenta';
  },
  
  // Get submit button text
  get submitText() {
    if (this.loading) return 'Cargando...';
    if (this.isOffline) return 'Sin conexión';
    return this.showLogin ? 'Entrar' : 'Registrarse';
  },
  
  // Get toggle text
  get toggleText() {
    return this.showLogin 
      ? '¿No tienes cuenta? Regístrate' 
      : '¿Ya tienes cuenta? Inicia sesión';
  }
});